

import React, {
  useEffect
}                           from 'react';
import { useSelector }      from 'react-redux';
import {
  useTranslate,
  useDomain
}                           from '../../../hooks/use';
import {
  SignInForm
}                           from './components'
import UiKit                from '../../../common/uikit';
import { useHistory }       from "react-router-dom";


export const SignIn = () => {
  const t                     = useTranslate();
  const history               = useHistory();
  const { signin }            = useDomain({ SignIn: {} });
  const redux                 = useSelector( state => ({
      isLoading       : state.getIn([ 'ui', 'provider', 'isLoading', 'Load_Product_Domain_Data' ]),
      token           : state.getIn([ 'domain', 'account', 'auth', 'token'])
  }));
  
  const token = redux.token ? redux.token : null;
  const path = window.location.pathname == "admin" ? true : false
  const onClickHandler = () => {
      return signin.startLogin();
  }

  useEffect(() => {
    if(token) {
      history.push("/dashboard");
    }
  }, [token])

  return (
    <>
      <SignInForm />
      <UiKit.Toast />
    </>
  );
}

export default SignIn;